import PropTypes from 'prop-types'
import React from 'react'
import ManageMailboxDelegationsModal from '../ManageMailboxDelegationsModal/ManageMailboxDelegationsModal'
import { useMailboxDelegationsState } from '../useMailboxDelegations'

const propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  customerId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  employee: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    employeeId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
}

function MailboxPermissionsModal({ show = false, onHide = () => {}, customerId = null, employee = null }) {
  const employeeId = employee?.id ?? employee?.employeeId ?? null
  const { status, delegations, errorCode, pending, refreshing, refreshErrorCode, retry, applyChange } =
    useMailboxDelegationsState({
      customerId,
      employeeId,
      enabled: show,
    })

  return (
    <ManageMailboxDelegationsModal
      show={show}
      onHide={onHide}
      customerId={customerId}
      employeeId={employeeId}
      delegations={delegations}
      loadStatus={status}
      loadErrorCode={errorCode}
      pending={pending}
      refreshing={refreshing}
      refreshErrorCode={refreshErrorCode}
      onRetry={retry}
      onChange={applyChange}
    />
  )
}

MailboxPermissionsModal.propTypes = propTypes

export default React.memo(MailboxPermissionsModal)
